import React, {useContext} from "react";
import { FaMapMarkerAlt} from "react-icons/fa";
import { FiUser, FiPieChart, FiTag, FiGrid,FiLogOut } from "react-icons/fi";
import logoWhite from "../assets/medicare-club-logo-white.svg";
import { useHistory } from "react-router-dom";
import {UserContext} from "../context/UserContext";
import { slide as Menu } from 'react-burger-menu'
import {Dropdown} from 'react-bootstrap';

function MainNav(props) {
    const history = useHistory();
    const [user, setUser] = useContext(UserContext);
    function logoutClick() {
        localStorage.removeItem('provider_token');
        localStorage.removeItem('provider_data');
        localStorage.removeItem('location_data');
        history.push("/");
    }

    function onLocationChange(item) {
      setUser({
          ...user,
          location_name: item.commercial_name,
          location_id: item.location_id,
          selected: item
      });
      localStorage.setItem('location_data', JSON.stringify(item));
    }
  
    let dropdownItems = user.locations.map((item, index)=>{
      return(
        <Dropdown.Item active={item.location_id === user.location_id ? true : false} key={item.location_id} onSelect={()=> onLocationChange(item)}>{item.commercial_name}</Dropdown.Item>
      )
    });
   
    return (
      <div>
        {/* <img src={logo} alt="logo" className="topLogo"></img> */}
        <Menu>
          <a href="#/home" className={`menu-item ${props.page === "home" ? "select" : ""}`} onClick={()=> history.push("/home")}><FiGrid/><span>Validar Desconto</span></a>
          <a href="#/stats" className={`menu-item ${props.page === "stats" ? "select" : ""}`} onClick={()=> history.push("/stats")}><FiPieChart/>Estatísticas</a>
          <a href="#/offers" className={`menu-item ${props.page === "offers" ? "select" : ""}`} onClick={()=> history.push("/offers")}><FiTag/>Ofertas e Descontos</a>
          <a href="#/perfil" className={`menu-item ${props.page === "perfil" ? "select" : ""}`} onClick={()=> history.push("/perfil")}><FiUser/>Meu Perfil</a>
          <a href="#/" className="menu-item" onClick={()=> logoutClick()}><FiLogOut/>Logout</a>
          <hr className="sep" />
          {user.locations.length > 0 ? 
              <Dropdown>
                <Dropdown.Toggle variant="danger" size="sm">
                <FaMapMarkerAlt className="mr-0"/> {user.location_name}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {dropdownItems}
                </Dropdown.Menu>  
              </Dropdown>
               
            : null} 
          <img src={logoWhite} alt="logo" className="bottomLogo"></img> 
        </Menu>
        
        {/* <Button variant="danger" size="lg" className="quickLink" onClick={()=> history.push("/home")}><FaQrcode/></Button> */}
      </div>
    )
}

export default MainNav;